__turbopack_context__.v({
  "active": "Xa4yJW_active",
  "divider": "Xa4yJW_divider",
  "other": "Xa4yJW_other",
  "tab": "Xa4yJW_tab",
  "tabs": "Xa4yJW_tabs",
  "wrapper": "Xa4yJW_wrapper",
});
